import type { Monitor, Project, Snapshot, Stream } from './api.js';

export interface DashboardData { snapshot: Snapshot; projects: Project[]; streams: Stream[]; monitors: Monitor[] }
type Request = <T>(path: string) => Promise<T>;

/** Coalesce callers only while a read is in flight; mutations never reuse cached data. */
export const singleFlight = <T>() => {
  let pending: Promise<T> | null = null;
  return (work: () => Promise<T>): Promise<T> => {
    if (pending) return pending;
    pending = Promise.resolve().then(work).finally(() => { pending = null; });
    return pending;
  };
};

export const createDashboardLoader = (request: Request, onSession?: (authenticated: boolean) => void) => {
  const run = singleFlight<DashboardData | null>();
  return () => run(async () => {
    const session = await request<{ authenticated: boolean }>('/api/session');
    onSession?.(session.authenticated);
    if (!session.authenticated) return null;
    return request<DashboardData>('/api/admin/dashboard');
  });
};
